import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Redirect, withRouter } from'react-router';

const UnAuthenticatedRoute = ({component: Component, ...rest}) => (
  <Route {...rest} render={props => localStorage.getItem("accessToken")==null ? (
      <Component {...props}/>
  ):(
      <Redirect to={{pathname: "/dashboard/server", state: {from: props.location}}}/>
  )
  } />
);

export default withRouter(UnAuthenticatedRoute);